module.exports = __webpack_public_path__ + "img/icon-basket-header.8d37901f.svg";